import { useCallback, useEffect, useState } from "react";
import { CheckCircle, XCircle, ArrowsClockwise } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/AppShell";
import { api, errMsg } from "@/lib/api";

export function AdsStatusCard() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = useCallback(() => {
    setBusy(true); setErr("");
    api.get("/admin/ads-status").then((r) => setData(r.data)).catch((e) => setErr(errMsg(e))).finally(() => setBusy(false));
  }, []);
  useEffect(() => { load(); }, [load]);
  const action = <Button size="sm" variant="outline" className="rounded-full" onClick={load} disabled={busy} data-testid="ads-status-recheck-button"><ArrowsClockwise size={14} className={`mr-1 ${busy ? "animate-spin" : ""}`} />{busy ? "Checking..." : "Check again"}</Button>;
  return (
    <Panel title="AdSense & search setup (live site)" action={action} className="mb-6" testid="ads-status-card">
      {err && <p className="text-sm text-red-600" data-testid="ads-status-error">{err}</p>}
      {!data && !err && <p className="text-sm text-muted-foreground">Checking {busy ? "..." : ""}</p>}
      {data && (
        <>
          <ul className="grid gap-3 sm:grid-cols-2">
            {data.checks.map((c) => {
              const Icon = c.ok ? CheckCircle : XCircle;
              return (
                <li key={c.key} className="flex gap-2.5 text-sm" data-testid={`ads-status-${c.key}`}>
                  <Icon size={20} weight="fill" className={c.ok ? "text-emerald-600 shrink-0" : "text-red-600 shrink-0"} />
                  <div className="min-w-0"><p className="font-medium">{c.label}</p>
                    <p className="text-xs text-muted-foreground truncate"><span data-testid={`ads-status-${c.key}-state`}>{c.ok ? "Live" : "Not found"}</span> · {c.detail} · <a href={c.url} target="_blank" rel="noopener noreferrer" className="underline">open</a></p></div>
                </li>
              );
            })}
          </ul>
          <p className="text-xs text-muted-foreground mt-3" data-testid="ads-status-meta">{data.site} · {data.publisher} · checked {new Date(data.checked_at).toLocaleString()}</p>
        </>
      )}
    </Panel>
  );
}
